module.exports = __webpack_public_path__ + "d0165560ffdf238dce2d110f52ccd8a5.svg";